import { batchExamTypeDto } from "DataMapper/IeltsDateUploadData"
import { CountryCode } from "DataMapper/CountryCode"

export interface FeatureList {
  heading: string
  description: string
  mobileHeading: string
}
export interface CourseDescription {
  title: string
  featureList: Array<FeatureList> | null
}
export interface BatchesBannerCarouselSchema {
  name: string
  icon: string
  heading: string
  mobileHeading: string
  headingColor: string
  subHeading?: string
  mobileSubHeading: string
  subHeadingColor?: string
  webimage: string
  mobileImage: string
  buttonText?: string
  buttonIcon?: string
  buttonTextColor?: string
  backGroundColor: string
  featureHeadingColor: string
  courseDescription: CourseDescription
  buttonBackground?: string
  buttonLink?: string
}

export interface AllIeltsBatches {
  filters: Record<string, Array<BatchSchema>>
}

export enum BatchesTypeDto {
  PRIME = "PRIME",
  PLUS = "PLUS",
  FOCUS = "FOCUS",
}

export interface BatchSchema {
  batchAlternateImage: string
  image: string
  startDate: string
  startTime: string
  endTime: string
  weeklySchedule: string
  offerPrice: number
  numberOfSeats: number
  seatBooked: number
  batchId: number
  pricingBundleName: string
  title: string
  currency: string
  teacherName: string
  teacherProfileImage: string
  tag: string
  strickedOfferPrice: number
  totalHours: number
  teacherBgImageColor: string
  bundleType: string
  courseDuration: number
  seatStatus?: SeatStatusEnum
  productTypes?: Array<ProductType>
  batchCategory?: batchExamTypeDto
  batchType?: BatchesTypeDto
}

export enum SeatStatusEnum {
  AVAILABLE = "AVAILABLE",
  FAST_FILLING = "FAST_FILLING",
  ALMOST_FILLED = "ALMOST_FILLED",
  FILLED = "FILLED",
}

export interface CarouselSettings {
  dots: boolean
  infinite: boolean
  speed: number
  centerMode: boolean
  centerPadding?: string
  slidesToShow: number
  slidesToScroll: number
  arrows: boolean
  autoplay: boolean
  autoplaySpeed: number
  nextArrow: any
  prevArrow: any
  responsive: {
    breakpoint: number
    settings: {
      slidesToShow: number
      slidesToScroll?: number
      centerPadding?: string
      nextArrow?: any
      prevArrow?: any
      arrows?: boolean
    }
  }[]
}

export enum BatchesFilters {
  ALL_BATCHES = "All Batches",
  WEEK_DAY_BATCHES = "Weekday Batches",
  WEEKEND_BATCHES = "Weekend Batches",
  EVENING_BATCHES_ONLY = "Evening Batches Only",
  STARTING_IN_2_DAYS = "Starting within 2 days",
  BAND_ASSURANCE = "Band Assurance",
}

export enum ProductType {
  BAND_ASSURANCE = "BAND_ASSURANCE",
}

export enum BatchType {
  IELTS = "IELTS",
  PTE = "PTE",
  DET = "DET",
}
